import tw from 'twin.macro';
import styled from '@emotion/styled';

import Icon from '@/components/Icon/IconSprite';

export const StyledTextareaContainer = styled.div`
  ${tw`relative`}
  ${tw`flex flex-col`}
`;

export const StyledTextarea = styled.textarea<{ hasError: boolean }>`
  ${tw`outline-none`}
  ${tw`px-2 py-[12px] gap-1`}
  ${tw`flex items-center shrink-0 self-stretch`}
  ${tw`rounded-[6px]`}
  ${tw`border border-neutrals-n6 focus:border-neutrals-n7`}
  ${tw`bg-neutrals-n1`}
  ${tw`leading-6`}

  ::placeholder {
    ${tw`flex flex-col justify-center self-stretch grow shrink-0 basis-0`}
    ${tw`font-inter font-regular`}
    ${tw`text-body-s text-neutrals-n7`}
  }

  &:focus,
  &:active {
    ::placeholder {
      ${tw`text-primary-p1`}
    }
  }

  ${({ hasError }) => hasError && [tw`border-primary-p2`]}
  ${({ disabled }) => disabled && tw`cursor-not-allowed opacity-50`}}
`;

export const StyledErrorIcon = styled(Icon)`
  ${tw`absolute top-[50%] right-[12px]`}
  ${tw`font-inter font-medium`}
  ${tw`text-body-s text-primary-p2`}
  ${tw`w-[24px] h-[24px]`}
  ${tw`transform -translate-y-1/2`}
`;
